import type { ReactNode } from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';
import { FormationCoverImage } from './FormationCoverImage';
import { formationCardGradient } from './utils';
import './lo-formation-cards.css';

export interface LoFormationTrainerRowCardProps {
  title: string;
  formationId: string;
  coverImageUrl?: string | null;
  learnerCount?: number | null;
  averageRating?: number | null;
  completionRate?: number | null;
  fallbackMeta?: string | null;
  onClick?: () => void;
  actionsSlot?: ReactNode;
  className?: string;
}

export function LoFormationTrainerRowCard({
  title,
  formationId,
  coverImageUrl,
  learnerCount,
  averageRating,
  completionRate,
  fallbackMeta,
  onClick,
  actionsSlot,
  className,
}: LoFormationTrainerRowCardProps) {
  const showLearners = learnerCount != null;
  const showRating = averageRating != null && averageRating > 0;
  const showCompletion = completionRate != null;

  return (
    <div
      className={cn('lo-fc-trainer', className)}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="lo-fc-trainer__thumb">
        <FormationCoverImage
          coverImageUrl={coverImageUrl}
          className="h-full w-full object-cover"
          fallback={(
            <div
              className="lo-fc-market__gradient h-full w-full"
              style={{ background: formationCardGradient(formationId) }}
            />
          )}
        />
      </div>
      <div className="lo-fc-trainer__body">
        <p className="lo-fc-trainer__title">{title}</p>
        <div className="lo-fc-trainer__stats">
          {showLearners ? (
            <span><strong>{learnerCount}</strong> apprenants</span>
          ) : null}
          {showRating ? (
            <span className="inline-flex items-center gap-0.5">
              <Star className="lo-fc-trainer__stats-star h-3 w-3 fill-current" aria-hidden />
              <strong>{averageRating!.toFixed(1)}</strong> note moyenne
            </span>
          ) : null}
          {showCompletion ? (
            <span><strong>{Math.round(completionRate!)}%</strong> taux de complétion</span>
          ) : null}
          {!showLearners && !showRating && !showCompletion ? (
            <span>{fallbackMeta ?? 'Statistiques bientôt disponibles'}</span>
          ) : null}
        </div>
      </div>
      {actionsSlot ? (
        <div className="lo-fc-trainer__actions" onClick={(e) => e.stopPropagation()}>
          {actionsSlot}
        </div>
      ) : null}
    </div>
  );
}
